import { Component, OnInit } from '@angular/core';
import { BackNavigationService } from '@irian-ro/shared-components-module';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subject } from 'rxjs';
import { AbstractContactContext, AbstractContactVO } from '@well/domain';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { DelContactEmailableResourceService, NotifiableContactResourceService } from '@well/resource-services';

@Component({
  selector: 'well-abstract-notifiable-entity-contact-list-update-popup',
  templateUrl: './abstract-notifiable-entity-contact-list-update-popup.component.html',
  styleUrls: ['./abstract-notifiable-entity-contact-list-update-popup.component.scss'],
})
export class AbstractNotifiableEntityContactListUpdatePopupComponent implements OnInit {
  selectedContactsUuids: string[] = [];
  contactList: AbstractContactVO[] | null = null;

  private context: AbstractContactContext | undefined = undefined;
  private abstractNotifiableEntityUuid: string | undefined = undefined;
  private businessProfileUuids: string[] | undefined = undefined;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private router: Router,
    private backNavigationService: BackNavigationService,
    private route: ActivatedRoute,
    private notifiableContactResourceService: NotifiableContactResourceService,
    private delContactResourceService: DelContactEmailableResourceService
  ) {}

  ngOnInit(): void {
    this.fetchContacts();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  private fetchContacts() {
    this.route.params
      .pipe(
        takeUntil(this.destroy$),
        switchMap((params) => {
          this.context = params['context'];
          this.abstractNotifiableEntityUuid = params['abstractNotifiableEntityUuid'];
          this.businessProfileUuids = params['businessProfileUuid'].split(',');

          return forkJoin(
            this.businessProfileUuids?.length > 1
              ? this.delContactResourceService.findAllEmailableContactsForBusinessProfiles(
                  this.businessProfileUuids,
                  this.context
                )
              : this.delContactResourceService.findAllEmailableContactsBasedOnBusinessProfile(
                  this.businessProfileUuids[0],
                  this.context
                ),
            this.notifiableContactResourceService.getNotifiableContactsForEntityUuid(this.abstractNotifiableEntityUuid)
          );
        })
      )
      .subscribe((res: [AbstractContactVO[], AbstractContactVO[]]) => {
        this.contactList = res[0];
        const missingContacts = res[1].filter(
          (existingEntityContact) =>
            this.contactList?.findIndex((contact) => contact.uuid === existingEntityContact.uuid) === -1
        );
        this.contactList.push(...missingContacts);
        this.selectedContactsUuids = res[1].map((i) => i.uuid);
      });
  }

  onSubmitContacts() {
    this.notifiableContactResourceService
      .updateNotifiableContactsForEntityUuid(this.abstractNotifiableEntityUuid, this.selectedContactsUuids)
      .subscribe((res: any) => {
        this.backNavigationService.back({
          abstractNotifiableEntityUuid: this.abstractNotifiableEntityUuid,
          abstractContacts: res,
        });
      });
  }
}
